export default "/images/c43c07dd2663dd98001e503f81655c05.avif";